import { render } from "./ui-dropdown.vue?vue&type=template&id=a343f2c4&scoped=true&ts=true"
import script from "./ui-dropdown.vue?vue&type=script&lang=ts"
export * from "./ui-dropdown.vue?vue&type=script&lang=ts"

import "./ui-dropdown.vue?vue&type=style&index=0&id=a343f2c4&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a343f2c4"]])

export default __exports__